import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const invoicePrinted = (invoice) => {
    return invoice 
                ? <FiberManualRecordIcon sx={{ color: "green",fontSize:"12px" }}  />
                : <FiberManualRecordIcon sx={{ color: "red",fontSize:"12px" }} />;
}